import React, { useState } from "react";
import { useUserModel } from "../userModel";
import { YHDrawer } from "@components/YhDrawer";
import { message, Spin, TreeSelect } from "antd";
import { ArrowDownOutlined } from "@ant-design/icons";
import { userService } from "../UserService";
import { globalPrompt } from "@src/components/YhMessage";
import useGlobalModel from "@src/model/globalModel";
import { ITreeData } from "../../menu/menuModel";
import { DataNode } from "antd/lib/tree";
import { IOrganDetail } from "@src/views/authPortal/base/org/organizationTypes";

const { TreeNode } = TreeSelect;

export function TransferOrgDrawer() {
    const {
        transferVisible,
        setTransferVisible,
        orgDs,
        loadData,
    } = useUserModel();

    const { globalLoading } = useGlobalModel()

    const [oldOrg, setOldOrg] = useState<string>()
    const [newOrg, setNewOrg] = useState<string>()

    const onCancel = () => {
        setTransferVisible(false);
    }

    const onOk = () => {
        if(!oldOrg) return globalPrompt("message", {type: 'warning', text: "请输入待迁出的组织机构"})
        if(!newOrg) return globalPrompt("message", {type: 'warning', text: "请输入待迁入的组织机构"})
        globalLoading()
        userService.transferOrg(oldOrg as string,newOrg as string).then(({retData}) => {
            globalLoading(false)
            if(retData){
                message.success("更新成功")
                loadData().then() 
                onCancel();
            } else {
                message.error("更新失败");
            }
        }).catch(error => {
            globalLoading(false)
        })
    }
    const createNode = (nodeData: ITreeData<IOrganDetail>) => {
        return <TreeNode key={nodeData.key} value={nodeData.value as string} title={nodeData.title} >
            {
                nodeData.children && nodeData.children.length > 0 && nodeData.children.map( item => createNode(item))
            }
        </TreeNode>
    }
    return (
        <YHDrawer
            {...{
                title: "部门用户迁移",
                visible: transferVisible,
                onOk,
                onCancel,
                showFooter: true,
                okText: '保存',
                cancelText: '取消',
            }}
        >
            <TreeSelect
                allowClear
                className="ant-select-round"
                value={oldOrg}
                onChange={(value) => setOldOrg(value)}
                placeholder="源组织机构"
            >
                {
                    orgDs?.map( item => createNode(item as any))
                }
            </TreeSelect>
            <div style={{textAlign: 'center',margin: '20px'}}>
                <ArrowDownOutlined style={{fontSize: '20px'}}/>
            </div>
            <TreeSelect
                allowClear
                className="ant-select-round"
                value={newOrg}
                onChange={(value) => setNewOrg(value)}
                placeholder="新组织机构"
                treeData={orgDs}
            />
        </YHDrawer>
    )
}
